import styled from 'styled-components';

export const ExerciseRow = styled.div`
    width: 100%;
    height: 45px;
    border-bottom: 1px solid #363636;
    padding-left: 5px;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
        background-color: #2a2d32;
        transition: all ease-in 0.25s;
    }
`;

export const ExerciseIcon = styled.div`
    width: 32px;
    height: 32px;
    background-image: url(${({ img }) => (img ? img : null)});
    background-size: cover;
    margin-right: 12px;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/ExerciseRow/style.js